import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../../translations/i18n";
import classes from "./CookieDisclaimer.module.scss";

interface CookieDisclaimerProps {
  userName: string | undefined;
}

export const getCookieDisclaimerKey = (
  userName: string,
  confirmedKey: string
) => {
  return `${userName}_${confirmedKey}`;
};

export const confirmedCookieKey = "cookiesAcknowledged";

const CookieDisclaimer: React.FC<CookieDisclaimerProps> = ({ userName }) => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);

  const getContent = (): JSX.Element => (
    <p className={classes.cookieMessage}>
      {t("message_cookies")}
      <a target="_blank" rel="noreferrer" href="https://www.ehs.com/privacy/">
        {t("message_read_more_here")}
      </a>
      {t("message_continuing_use_consent")}
    </p>
    // END TODO: Translate - Break "cookies_Disclaimer" into multiple translations for formatting
  );

  const setCookieDisclaimerDismissed = () => {
    if (userName) {
      window.localStorage[
        getCookieDisclaimerKey(userName, confirmedCookieKey)
      ] = true;
    }
  };

  const isNoCookie = () => {
    return (
      userName &&
      !window.localStorage[getCookieDisclaimerKey(userName, confirmedCookieKey)]
    );
  };

  const showDisclaimer = () => {
    const content = getContent();
    toast.current?.replace({ severity: "info", content, sticky: true });
  };

  useEffect(() => {
    if (isNoCookie()) {
      showDisclaimer();
    }
    // eslint-disable-next-line
  }, []);

  i18n.on("languageChanged", () => {
    if (isNoCookie()) {
      showDisclaimer();
    }
  });

  return (
    <div className={classes.cookieToastContainer}>
      <Toast
        ref={toast}
        baseZIndex={3000}
        className={classes.cookieToast}
        onRemove={setCookieDisclaimerDismissed}
        position="bottom-center"
      />
    </div>
  );
};

export default CookieDisclaimer;
